var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"cancel-text":'_.close',"title":_vm.title},on:{"close":function($event){return _vm.$emit('close')}}},[_c('u-pretty-json',{attrs:{"data":_vm.log}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }